<template>
    <span>Logging out...</span>
</template>

<script>
import AuthService from "../services/AuthService.js";

export default {
    mounted : function(){
        AuthService.logout().then(() => {
            this.$router.push({
                path: '/login'
            });
        });
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LogoutComponent.vue